import { render, staticRenderFns } from "./zyPlayer.vue?vue&type=template&id=6b291f2e&scoped=true"
import script from "./zyPlayer.vue?vue&type=script&lang=js"
export * from "./zyPlayer.vue?vue&type=script&lang=js"
import style0 from "./zyPlayer.vue?vue&type=style&index=0&id=6b291f2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b291f2e",
  null
  
)

export default component.exports